import axios from 'axios';
import Common from './Common';
export default {
    getSales(id) {
        return axios.get(Common.api + 'seller-sold/' + id);
    }
}